import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { map } from 'rxjs/operators';

export const noAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    map((isAuthenticated) => {
      if (isAuthenticated) {

        const redirectUrl = route.queryParams['redirectUrl'];
        if (redirectUrl) {
          router.navigateByUrl(redirectUrl);
        } else {
          router.navigate(['/dashboard']);
        }
        return false;
      }

      return true;
    }),
  );
};
